<div class="content-card card">
    <ng-content select="kui-card-header"></ng-content>
    <ng-content select="kui-card-jumbotron"></ng-content>
    <ng-content select="kui-card-body"></ng-content>
    <ng-content select="kui-card-footer"></ng-content>
</div>